import {
	ClockCircleOutlined,
	EnvironmentOutlined,
	GlobalOutlined,
	InfoCircleOutlined,
	LinkOutlined,
	PictureOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Divider, Image, List, Row, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import BerninaHero from "../components/BerninaHero";
import PageLayout from "./PageLayout";

const { Title, Paragraph, Text, Link } = Typography;

const BerninaInfo = () => {
	const { t } = useTranslation();
	const stopImages = [
		"https://upload.wikimedia.org/wikipedia/commons/5/59/Santuario-Madonna-Tirano.jpg",
		"https://upload.wikimedia.org/wikipedia/commons/6/6e/Brusio_Viaduct_%28158241421%29.jpeg",
		"https://upload.wikimedia.org/wikipedia/commons/e/e5/Cavaglia%2C_2014_%2802%29.JPG",
		"https://upload.wikimedia.org/wikipedia/commons/9/9d/Alp_Gruem_view_to_Valposchiavo-Lake_Poschiavo-01.jpg",
		"https://upload.wikimedia.org/wikipedia/commons/f/f1/Lago_Bianco_from_Diavolezza.jpg",
		"https://upload.wikimedia.org/wikipedia/commons/e/ec/Vadret_da_Morteratsch_-_panoramio_%2827%29.jpg",
		"https://upload.wikimedia.org/wikipedia/commons/b/b2/Valley_leading_to_pontresina.jpg",
		"https://upload.wikimedia.org/wikipedia/commons/f/f9/St_Moritz_Muottas.jpg",
	];
	return (
		<PageLayout fullWidthContent={<BerninaHero />}>
			<div style={{ maxWidth: 1200, margin: "0 auto", padding: "24px" }}>
				<Row gutter={[24, 24]}>
					{/* Train Types Section */}
					<Col xs={24}>
						<Card
							title={t("berninaInfo.typesOfTrains")}
							hoverable
							style={{ height: "100%", borderColor: "#d9d9d9" }}
						>
							<Row gutter={[16, 16]}>
								<Col xs={24}>
									<Title level={5}>{t("berninaInfo.regularRedTrains")}</Title>
									<ul>
										{t("berninaInfo.regularDesc", { returnObjects: true }).map(
											(item, index) => (
												<li key={index}>{item}</li>
											),
										)}
									</ul>
									<Row gutter={[8, 8]} style={{ marginTop: 16 }}>
										<Col xs={24}>
											<Image
												src="https://b2052345.smushcdn.com/2052345/wp-content/uploads/2022/04/second-class-regional-switzerland-1024x576.jpg?lossy=1&strip=1&webp=1"
												alt="Bernina Red Train"
												style={{ width: "100%", borderRadius: "4px" }}
												preview={false}
											/>
										</Col>
										<Col xs={24}>
											<Image
												src="https://images.visititaly.eu/uploads/articoli/paragrafo/2022102147percorso-bernina-express-fermate-consigliate.jpg"
												alt="Landwasser Viaduct"
												style={{ width: "100%", borderRadius: "4px" }}
												preview={false}
											/>
										</Col>
									</Row>
								</Col>
								<Col xs={24}>
									<Title level={5}>{t("berninaInfo.berninaExpress")}</Title>
									<ul>
										{t("berninaInfo.expressDesc", { returnObjects: true }).map(
											(item, index) => (
												<li key={index}>{item}</li>
											),
										)}
									</ul>
									<Row gutter={[8, 8]} style={{ marginTop: 16 }}>
										<Col xs={24}>
											<Image
												src="https://www.treninorosso.it/media/3928/dsc05414.jpg"
												alt="Bernina Express Panoramic Carriage"
												style={{ width: "100%", borderRadius: "4px" }}
												preview={false}
											/>
										</Col>
										<Col xs={24}>
											<Image
												src="https://images.eu.ctfassets.net/h76myjvzsgnd/7kA9Yhc4QoJMuvzyqu8g2X/2e8e6ad2f357df08db907689eb29ffe2/Bernina_Express_in_der_Montebellokurve__8_.jpg"
												alt="Bernina Express in Montebello Curve"
												style={{ width: "100%", borderRadius: "4px" }}
												preview={false}
											/>
										</Col>
									</Row>
								</Col>
							</Row>
							<Divider />
							<Paragraph>
								<InfoCircleOutlined style={{ color: "#1890ff" }} />{" "}
								<strong>Note:</strong> {t("berninaInfo.note")}
							</Paragraph>
						</Card>
					</Col>

					{/* Timetables Section */}
					<Col xs={24}>
						<Card
							title={
								<>
									<ClockCircleOutlined /> {t("berninaInfo.timetables")}
								</>
							}
							hoverable
							style={{ height: "100%", borderColor: "#d9d9d9" }}
						>
							<Paragraph>
								<strong>{t("berninaInfo.generalSchedule")}</strong>
							</Paragraph>
							<Row gutter={[16, 16]} style={{ marginTop: 24 }}>
								<Col xs={24} md={12}>
									<a
										href="https://www.sbb.ch/en?stops=%5B%7B%22value%22:%228509369%22,%22label%22:%22Tirano%22,%22type%22:%22ID%22%7D,%7B%22value%22:%228509253%22,%22label%22:%22St.+Moritz%22,%22type%22:%22ID%22%7D%5D&reductionCode=%22NONE%22"
										target="_blank"
										rel="noopener noreferrer"
										style={{
											display: "block",
											height: "100%",
											textDecoration: "none",
										}}
									>
										<Card
											hoverable
											style={{
												height: "100%",
												borderColor: "#1890ff",
												textAlign: "center",
												display: "flex",
												flexDirection: "column",
												justifyContent: "center",
											}}
											bodyStyle={{ padding: "24px" }}
										>
											<ClockCircleOutlined
												style={{
													fontSize: "32px",
													color: "#1890ff",
													marginBottom: 16,
												}}
											/>
											<Title
												level={5}
												style={{ color: "#1890ff", marginBottom: 8 }}
											>
												{t("berninaInfo.sbbTimetable")}
											</Title>
											<Text type="secondary">{t("berninaInfo.sbbDesc")}</Text>
										</Card>
									</a>
								</Col>
								<Col xs={24} md={12}>
									<a
										href="https://www.berninarailway.com/bernina-experience-informations-and-usefull-tips/"
										target="_blank"
										rel="noopener noreferrer"
										style={{
											display: "block",
											height: "100%",
											textDecoration: "none",
										}}
									>
										<Card
											hoverable
											style={{
												height: "100%",
												borderColor: "#52c41a",
												textAlign: "center",
												display: "flex",
												flexDirection: "column",
												justifyContent: "center",
											}}
											bodyStyle={{ padding: "24px" }}
										>
											<InfoCircleOutlined
												style={{
													fontSize: "32px",
													color: "#52c41a",
													marginBottom: 16,
												}}
											/>
											<Title
												level={5}
												style={{ color: "#52c41a", marginBottom: 8 }}
											>
												{t("berninaInfo.berninaTips")}
											</Title>
											<Text type="secondary">{t("berninaInfo.tipsDesc")}</Text>
										</Card>
									</a>
								</Col>
							</Row>
						</Card>
					</Col>

					{/* Helpful Tips Section */}
					<Col xs={24}>
						<Card
							title={
								<>
									<InfoCircleOutlined /> {t("berninaInfo.helpfulTips")}
								</>
							}
							style={{ background: "#f0f5ff", borderColor: "#adc6ff" }}
						>
							<Row gutter={[16, 16]}>
								<Col xs={24} md={8}>
									<strong>{t("berninaInfo.reservation")}</strong>
								</Col>
								<Col xs={24} md={8}>
									<strong>{t("berninaInfo.swissPass")}</strong>
								</Col>
								<Col xs={24} md={8}>
									<strong>{t("berninaInfo.seasonality")}</strong>
								</Col>
							</Row>
						</Card>
					</Col>

					{/* Highlights Map Section */}
					<Col xs={24}>
						<Card
							title={
								<>
									<PictureOutlined /> {t("berninaInfo.highlightsMap")}
								</>
							}
							hoverable
							style={{ height: "100%", borderColor: "#d9d9d9" }}
						>
							<Image
								src="https://www.berninarailway.com/bernina-express/wp-content/uploads/2023/02/Bernina-Express-Tips-and-Best-Place-to-visit.png"
								alt="Bernina Express Route Highlights"
								style={{ width: "100%", borderRadius: "8px" }}
							/>
						</Card>
					</Col>

					{/* Route on Google Maps Section */}
					<Col xs={24}>
						<Card
							title={
								<>
									<EnvironmentOutlined /> {t("berninaInfo.routeOnMaps")}
								</>
							}
							hoverable
							style={{ height: "100%", borderColor: "#d9d9d9" }}
						>
							<div
								style={{
									width: "100%",
									height: "400px",
									borderRadius: "8px",
									overflow: "hidden",
									marginBottom: "12px",
								}}
							>
								<iframe
									src="https://maps.google.com/maps?saddr=Tirano,+Italy&daddr=St.+Moritz,+Switzerland&ie=UTF8&t=m&z=9&output=embed"
									width="100%"
									height="100%"
									style={{ border: 0 }}
									allowFullScreen=""
									loading="lazy"
									referrerPolicy="no-referrer-when-downgrade"
									title="Bernina Express Route"
								/>
							</div>
							<Button
								type="primary"
								href="https://www.google.com/maps/dir/Tirano,+Tirano,+SO/Saint+Moritz,+Svizzera/@46.3635941,9.8608047,11z/data=!4m14!4m13!1m5!1m1!1s0x4783bccda0d853d7:0xe2b5a6af2166ba02!2m2!1d10.1669763!2d46.2155266!1m5!1m1!1s0x478482076dc01a7b:0x279fdbbd3ec97825!2m2!1d9.8355079!2d46.4907973!3e3?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D"
								target="_blank"
								icon={<EnvironmentOutlined />}
								block
							>
								{t("berninaInfo.openRoute")}
							</Button>
						</Card>
					</Col>

					{/* UNESCO Heritage Sites Section */}
					<Col xs={24}>
						<Card
							title={
								<>
									<GlobalOutlined /> {t("berninaInfo.unescoTitle")}
								</>
							}
							hoverable
							style={{ height: "100%", borderColor: "#d9d9d9" }}
						>
							<Image
								src="https://images.visititaly.eu/uploads/articoli/evidenza/2022110438BERNINA-EXPRESS-UNESCO-TRENINO-ROSSO.jpg"
								alt="Bernina Express UNESCO Route"
								style={{
									width: "100%",
									borderRadius: "8px",
									marginBottom: "16px",
								}}
							/>
							<Paragraph>
								<strong>{t("berninaInfo.unescoQuote")}</strong>
							</Paragraph>
							<Paragraph>{t("berninaInfo.unescoDesc")}</Paragraph>
							<Title level={5}>{t("berninaInfo.mostBeautifulStops")}</Title>
							<List
								itemLayout="vertical"
								dataSource={t("berninaInfo.stops", { returnObjects: true }).map(
									(stop, index) => ({ ...stop, image: stopImages[index] }),
								)}
								renderItem={(item) => (
									<List.Item
										extra={
											<Image
												width={150}
												alt={item.title}
												src={item.image}
												style={{ borderRadius: "4px", objectFit: "cover" }}
											/>
										}
									>
										<List.Item.Meta
											title={<Text strong>{item.title}</Text>}
											description={
												<Text style={{ color: "rgba(0, 0, 0, 0.65)" }}>
													{item.desc}
												</Text>
											}
										/>
									</List.Item>
								)}
							/>
							<Divider />
							<Text type="secondary" style={{ fontSize: "12px" }}>
								{t("berninaInfo.source")}
							</Text>
							<Button
								type="primary"
								href="https://www.visititaly.eu/unesco/bernina-express-red-train-unesco-since-2008"
								target="_blank"
								icon={<LinkOutlined />}
								block
								style={{ marginTop: 16 }}
							>
								{t("berninaInfo.readFullArticle")}
							</Button>
						</Card>
					</Col>
				</Row>
			</div>
		</PageLayout>
	);
};

export default BerninaInfo;
